import { useEffect, useState, useRef } from 'react';

export default function useDebounce(value, delay) {
  const [debouncedValue, setDebouncedValue] = useState(value);
  const previousValue = useRef(value);

  useEffect(() => {
    // Only set up the timeout if the value has actually changed
    if (JSON.stringify(previousValue.current) !== JSON.stringify(value)) {
      const handler = setTimeout(() => {
        setDebouncedValue(value);
      }, delay);

      previousValue.current = value;
      return () => clearTimeout(handler);
    }
  }, [value, delay]);

  return debouncedValue;
}
